import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { ChildrenProps } from 'types';

interface ProtectedRouteProps {
  allowed: boolean;
  redirect: string;
}

export const ProtectedRoute = ({
  children,
  redirect,
  allowed,
}: ChildrenProps<ProtectedRouteProps>): React.JSX.Element => {
  const router = useRouter();

  useEffect(() => {
    if (!allowed) {
      router.replace(redirect);
    }
  }, [allowed, redirect, router]);

  if (!allowed) {
    return <></>;
  }

  return <>{children}</>;
};
